import React, { useEffect, useRef } from "react";
import "./custominput.css";
import theme from "../../Constants/theme";

const CustomInput = ({
  width,
  placeholder,
  label,
  className,
  onHandleChange,
  type,
  additionalInfo,
  name,
  multiple,
  disable,
  upload_type,
  ref,
  resetInput,
}) => {
  const inputId = `file-input-${upload_type}`;
  const innerRef = useRef(null);
  const inputRef = ref || innerRef;

  useEffect(() => {
    if (resetInput && inputRef.current) {
      inputRef.current.value = "";
    }
  }, [resetInput]);

  return (
    <div className={`input ${className}`}>
      <div>
        <p>
          {label}
          <span className="additionalinfo">{additionalInfo}</span>
        </p>
      </div>
      {multiple === false ? (
        <div className="input-container">
          <input
            style={{ width: width }}
            placeholder={placeholder}
            name={name}
            onChange={onHandleChange}
            type={type}
            disabled={disable || false}
          />
        </div>
      ) : (
        <div className="file-input-container">
          <label htmlFor={inputId} className="custom-file-input-label">
            {placeholder}
          </label>
          {upload_type === "structured" && (
            <input
              ref={inputRef}
              multiple
              className="file-selector"
              id="file-input-structured"
              style={{ width: width }}
              name={name}
              onChange={onHandleChange}
              type={type}
              accept={`${
                upload_type === "structured" &&
                "text/csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              }`}
            />
          )}
          {upload_type === "folder-structured" && (
            <input
              ref={inputRef}
              multiple
              className="file-selector"
              id="file-input-folder-structured"
              style={{ width: width }}
              name={name}
              onChange={onHandleChange}
              webkitdirectory="true"
              directory="true"
              type={type}
              accept={`${
                upload_type === "structured" &&
                "text/csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              }`}
            />
          )}
          {upload_type === "folder-unstructured" && (
            <input
              ref={inputRef}
              multiple
              className="file-selector"
              id="file-input-folder-unstructured"
              style={{ width: width }}
              name={name}
              onChange={onHandleChange}
              webkitdirectory="true"
              directory="true"
              type={type}
              accept={`${
                upload_type === "folder-unstructured" &&
                "application/msword, text/plain, application/pdf, text/csv, text/markdown, text/x-markdown, .md"
              }`}
            />
          )}
          {upload_type === "folder-unstructured-meta" && (
            <input
              ref={inputRef}
              multiple
              className="file-selector"
              id="file-input-folder-unstructured-meta"
              style={{ width: width }}
              name={name}
              onChange={onHandleChange}
              webkitdirectory="true"
              directory="true"
              type={type}
              accept={`${
                upload_type === "folder-untructured-meta" &&
                "text/csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              }`}
            />
          )}
          {upload_type === "unstructured" && (
            <input
              ref={inputRef}
              multiple
              className="file-selector"
              id="file-input-unstructured"
              style={{ width: width }}
              name={name}
              onChange={onHandleChange}
              type={type}
              accept={`${
                upload_type === "unstructured" &&
                "application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, text/plain, application/pdf,  text/markdown, text/x-markdown, .md"
              }`}
            />
          )}
          {upload_type === "unstructured-meta" && (
            <input
              ref={inputRef}
              multiple
              className="file-selector"
              id="file-input-unstructured-meta"
              style={{ width: width }}
              name={name}
              onChange={onHandleChange}
              type={type}
              accept={`${upload_type === "unstructured-meta" && "text/csv"}`}
            />
          )}
          {upload_type === "finetuned" && (
            <>
              <input
                className="file-selector"
                ref={inputRef}
                multiple
                disabled={disable}
                id="file-input-finetuned"
                style={{ width: width }}
                name={name}
                onChange={onHandleChange}
                type={type}
                accept={`${upload_type === "finetuned" && "text/csv"}`}
              />
              <p style={{ color: theme.textColors.dark.primary }}>
                *Supported file types: CSV/XLXS (Excel format)
              </p>
            </>
          )}
          {upload_type === "dynamicShot" && (
            <>
              <input
                ref={inputRef}
                className="file-selector"
                multiple
                id="file-input-dynamicShot"
                style={{ width: width }}
                name={name}
                onChange={onHandleChange}
                type={type}
                accept={`${upload_type === "dynamicShot" && "text/csv"}`}
              />
              <p>*Supported file types: CSV</p>
            </>
          )}
          {upload_type === "fewShot" && (
            <>
              <input
                ref={inputRef}
                className="file-selector"
                multiple
                id="file-input-fewShot"
                style={{ width: width }}
                name={name}
                onChange={onHandleChange}
                type={type}
                accept={`${upload_type === "fewShot" && "text/csv"}`}
              />
              <p>*Supported file types: CSV</p>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default CustomInput;
